import React, { useRef, lazy } from "react";
import { Route, Routes } from "react-router-dom";
const Home = lazy(() => import("../Home"));
const Profile = lazy(() => import("../Profile"));
const ViewProfile = lazy(() => import("../ViewProfile"));
const TouchPoint = lazy(() => import("../TouchPoint"));
const TouchPointView = lazy(() => import("../TouchPointView"));
const TouchPointForm = lazy(() => import("../TouchPointForm"));
const Login = lazy(() => import("../Login"));
const Tutorial = lazy(() => import("../Tutorial"));
const OurBrand = lazy(() => import("../OurBrand"));
const Tasks = lazy(() => import("../Tasks"));
const UserList = lazy(() => import("../UserList"));
const Flockler = lazy(() => import("../Flockler"));
const MilestoneForm = lazy(() => import("../MilestoneForm"));
const CardForm = lazy(() => import("../CardForm"));
const OrgaBoard = lazy(() => import("../OrgaBoard"));
const Quiz = lazy(() => import("../Quiz"));
const QuizView = lazy(() => import("../Quiz/QuizView"));
const SurveyView = lazy(() => import("../Survey/SurveyView"));
const Survey = lazy(() => import("../Survey"));
const AuditForm = lazy(() => import("../AuditForm"));
const Journey = lazy(() => import("../Journey"));
const JourneyList = lazy(() => import("../JourneyList"));
const CustomPage = lazy(() => import("../CustomPage"));
const TimeTrial = lazy(() => import("../TimeTrial"));
const Sso = lazy(() => import("../Sso"));

export default function AllRoutes({ client, handleGoback, profile }) {
  const refMain = useRef(null);
  return (
    <div ref={refMain} className="main">
      <Routes>
        <Route path="/" element={<Home />} />
        {client?.customPage && (
          <Route exact path={`/${client?.customPage?.slug}`} element={<CustomPage body={client?.customPage?.body} />} />
        )}
        <Route exact path="/touchpoint" element={<TouchPoint role={profile?.role} />} />
        <Route exact path="/touchpoint/new" element={<TouchPointForm handleGoback={handleGoback} />} />
        <Route exact path="/touchpoint/edit/:touchPointId" element={<TouchPointForm handleGoback={handleGoback} />} />
        <Route exact path="/touchpoint/:touchPointId" element={<TouchPointView key={window.location.pathname} />} />
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/sso/*" element={<Sso />} />
        <Route exact path="/tutorial" element={<Tutorial />} />
        <Route exact path="/view-profile/:userId" element={<ViewProfile />} />
        <Route exact path="/profile" element={<Profile handleGoback={handleGoback} />} />
        <Route exact path="/our-brand" element={<OurBrand handleGoback={handleGoback} />} />
        <Route exact path="/tasks" element={<Tasks handleGoback={handleGoback} />} />
        <Route exact path="/community" element={<UserList handleGoback={handleGoback} />} />
        <Route exact path="/feed" element={<Flockler handleGoback={handleGoback} />} />
        <Route exact path="/milestone/new/:touchPointId" element={<MilestoneForm />} />
        <Route exact path="/card/:touchPointId" element={<CardForm />} />
        <Route exact path="/card/edit/:taskId" element={<CardForm />} />
        <Route exact path="/milestone/edit/:touchPointId" element={<MilestoneForm />} />
        <Route exact path="/orga-board" element={<OrgaBoard handleGoback={handleGoback} />} />
        <Route exact path="/quiz" element={<Quiz handleGoback={handleGoback} />} />
        <Route exact path="/quiz/:id" element={<QuizView handleGoback={handleGoback} />} />
        <Route exact path="/survey/:id" element={<SurveyView handleGoback={handleGoback} />} />
        <Route exact path="/survey" element={<Survey handleGoback={handleGoback} />} />
        <Route exact path="/journey" element={<JourneyList handleGoback={handleGoback} />} />
        <Route exact path="/journey/:journeyId" element={<Journey handleGoback={handleGoback} refMain={refMain} />} />
        <Route exact path="/audit/:touchPointId/:auditId" element={<AuditForm handleGoback={handleGoback} />} />
        <Route exact path="/tp-survey/:touchPointId/" element={<AuditForm handleGoback={handleGoback} />} />
        <Route exact path="/welcome/:userHash" element={<Profile handleGoback={handleGoback} />} />
        <Route exact path="/reset/:userHash" element={<Profile handleGoback={handleGoback} />} />
        <Route exact path="/timetrial/:taskId" element={<TimeTrial handleGoback={handleGoback} />} />
      </Routes>
    </div>
  );
}
